import { BlockEditProps } from "@wordpress/blocks";
import React from "react";
import type { BlockAttributes } from "./block.json";
import {
  InspectorControls,
  RichText,
  useBlockProps,
  useInnerBlocksProps,
} from "@wordpress/block-editor";
import ImageEditor from "../../../source/components/ImageEditor";
import {
  ToggleControl,
  PanelBody,
  PanelRow,
  TextControl,
} from "@wordpress/components";
import { lock } from "@wordpress/components/build-types/private-apis";

const ALLOWED_BLOCKS = ["core/image"];

export default function HeaderEditor(props: BlockEditProps<BlockAttributes>) {
  const blockProps = useBlockProps({ className: "alignfull" });
  const innerBlocksProps = useInnerBlocksProps(
    useBlockProps({
      className: "header-2-col alignfull w-100 d-flex flex-column flex-xl-row",
    }) as unknown as Record<string, unknown>,
    {
      allowedBlocks: ALLOWED_BLOCKS,
      template: [["core/image"], ["core/image"]],
      templateLock: "all",
    }
  );

  return (
    <>
      <div {...blockProps}>
        <div {...innerBlocksProps}></div>
      </div>
    </>
  );
}
